import { combineReducers } from "redux";
import evaluation from "./evaluation";
import clubDetails from "./clubDetails";
import common from "./common";
import library from "./library";
import clubData from "./clubData";
import licence from './licence';
import dataCaptures from "./dataCaptures";
import actionPlan from "./actionPlan";
import evaluationDashboard from "./evaluationDashboard";
import goalsAndStrategy from "./goalsAndStrategy";
import licenceAnalytics from "./licenceAnalytics";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Nested config for `common`: persists user/auth state but
// never caches data lists that come from the API / static source.
const commonPersistConfig: any = {
    key: "common",
    storage,
    blacklist: [
        "upcoming",
        "displayUpcoming",
        "myClubs",
        "displayMyClubs",
        "pinnedClubs",
        "projects",
        "displayProjects",
    ],
};

const persistConfig: any = {
    key: "root",
    storage,
    // `common` is handled by its own nested persistReducer below.
    blacklist: ["licenceAnalytics", "evaluation", "licence", "common"],
};

const rootReducer = combineReducers({
    evaluation,
    licence,
    clubDetails,
    common: persistReducer(commonPersistConfig, common),
    library,
    clubData,
    dataCaptures,
    actionPlan,
    evaluationDashboard,
    goalsAndStrategy,
    licenceAnalytics,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);
export default persistedReducer;
// export default rootReducer;